import styled from 'styled-components';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { ClassNameProp, TestableComponentProps, Text } from '@dreryk/react-components';

import { Price } from './price.types';

const StyledPriceText = styled(Text)`
   color: ${(props) => props.theme.placeholder};
`;

StyledPriceText.displayName = 'StyledPriceText';

type PriceTextProps = ClassNameProp &
   TestableComponentProps & {
      readonly value: Price;
      readonly stripDecimalZeroes?: boolean;
      readonly hideCurrency?: boolean;
   };

export const PriceText = (props: PriceTextProps): JSX.Element => {
   return (
      <StyledPriceText className={props.className} testId={props.testId} whiteSpaces={'nowrap'}>
         {priceFormatter(
            props.value,
            getCustomFormattingContext({
               options: {
                  currency: props.hideCurrency ? undefined : 'PLN',
                  stripDecimalZeroes: props.stripDecimalZeroes ?? false,
               },
            })
         )}
      </StyledPriceText>
   );
};
